<template>
  <ag-modal-container
    :title="$t('multiproject.title.createVersion')"
    width="900px"
    @close="back"
  >
    <version-form
      v-model="value"
      create
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        color="primary"
        class="ml-5"
        outlined
        @click="back"
        v-text="$t('general.cancel')"
      />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="$t('general.create')"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import AgModalContainer from 'src/components/common/AgModalContainer'
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import VersionForm from '../components/VersionForm'

export default {
  name: 'VersionCreateContainer',
  components: {
    AgModalContainer,
    VersionForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      name: '',
      lang: '',
      defaultVersion: false,
      projectList: [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
      ],
      blueName: '',
      redName: '',
      yellowName: '',
      greenName: '',
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.multiProject.version.post(this.value)
        this.showSuccessNotification(this.$t('multiproject.fields.success.versionCreated'))
        this.back()
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
